import {
  IPlineReconAccountsResponse,
  IPlineReconciliationArgs,
  IPlineReconciliationResponse,
  IPlineReconciliationWorkbook,
} from "types/PlineReconciliation";

import { api } from ".";

const queryString = ({ accountId, from, to }: IPlineReconciliationArgs) =>
  new URLSearchParams({ accountId, from, to }).toString();

// CLE-2917: SuperAdmin-only P-line / GL reconciliation. The reconciliation and its workbook are fetched
// on demand (lazy hooks) and never cached for long; the account list is cheap and cached normally.
const plineReconciliationQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getPlineReconAccounts: builder.query<IPlineReconAccountsResponse, void>({
      query: () => ({ url: "reports/pline-reconciliation/accounts" }),
    }),
    getPlineReconciliation: builder.query<
      IPlineReconciliationResponse,
      IPlineReconciliationArgs
    >({
      query: (args) => ({
        url: `reports/pline-reconciliation?${queryString(args)}`,
      }),
      keepUnusedDataFor: 0,
    }),
    // The same reconciliation as finance's workbook (.xlsx), fetched through the authenticated API so the
    // caller can trigger a browser save.
    getPlineReconciliationWorkbook: builder.query<
      IPlineReconciliationWorkbook,
      IPlineReconciliationArgs
    >({
      query: (args) => ({
        url: `reports/pline-reconciliation.xlsx?${queryString(args)}`,
        responseHandler: async (response: Response) => {
          if (!response.ok) {
            try {
              return await response.json();
            } catch {
              return { message: "Could not build the workbook." };
            }
          }
          return {
            blob: await response.blob(),
            fileName: `pline-reconciliation-${args.accountId}-${args.from}-${args.to}.xlsx`,
          };
        },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetPlineReconAccountsQuery,
  useLazyGetPlineReconciliationQuery,
  useLazyGetPlineReconciliationWorkbookQuery,
} = plineReconciliationQueries;
